/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@kubb/plugin-client/clients/fetch';
import type { PostAccountLanguageMutationRequest, PostAccountLanguageMutationResponse } from '../types/PostAccountLanguage.ts';
import type { Client, RequestConfig, ResponseErrorConfig } from '@kubb/plugin-client/clients/fetch';

function getPostAccountLanguageUrl() {
  const res = { method: 'POST', url: `/account/language` as const };
  return res;
}

/**
 * @description Update account language preference
 * @summary Update account language preference
 * {@link /account/language}
 */
export async function postAccountLanguage(
  data: PostAccountLanguageMutationRequest,
  config: Partial<RequestConfig<PostAccountLanguageMutationRequest>> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<PostAccountLanguageMutationResponse, ResponseErrorConfig<Error>, PostAccountLanguageMutationRequest>({
    method: 'POST',
    url: getPostAccountLanguageUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}
